const repository = require('./checkin_repository');
const mockedRepository = require('./checkin_repository.mock');

function factory(urlFormatter, ancillariesClient) {
    const repo = repository.factory(urlFormatter, ancillariesClient);
    const mockOptions = mockedRepository.getMockOptions();
    try {
        return mockOptions.anyMockForced || mockOptions.forceNoSeatsAvailable ?
            mockedRepository.factory(repo) :
            repo;
    } catch (e) {
        return repo;
    }
}

module.exports = {
    factory,
};
